<section class="main-section p-2">

    <div class="breadcrumb-container row gx-0 gy-0 p-2 w-100">

        <div class="d-flex align-items-center col-auto px-1">

            <span class="w-100 d-flex align-items-center" routerLink="/partners/dashboard">

                پنل داشبورد
                
            </span>

        </div>

        <div class="chevron-icon d-flex align-items-center col-auto px-1 ">

            <span class="w-100 d-flex align-items-center">

                <mat-icon class="text-muted">chevron_left</mat-icon>
                
            </span>

        </div>

        <div class="d-flex align-items-center col-auto px-1">

            <span class="w-100 d-flex align-items-center">

                گزارش مالی
                
            </span>

        </div>

    </div>

    <div class="table-container">

        <div class="border border-2 p-2" >

            <input class="w-100 form-control" placeholder="جستجو کنید ..." #keyValue (keyup)="filter_list($event.target)">

            <div class="section border border-2 mt-2">

                <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                    <thead>
            
                        <tr class="">
            
                            <th class="text-center"> # </th>
        
                            <th class="text-center"> کد سفر  </th>
        
                            <th class="text-center"> تاریخ سفر  </th>
                            
                            <th class="text-center"> بستانکار </th>
    
                            <th class="text-center"> بدهکاری </th>
    
                            <th class="text-center"> شرح </th>
    
                        </tr>
                        
                    </thead>

                    <tbody>

                        <tr class="col-12 text-center" *ngFor="let item of lst_Trip;let i = index">

                            <th> {{ i + 1 | faNum }} </th>

                            <td> {{ item.TaxiLon_Partner_DebitCredit | faNum }} </td>

                            <td> {{ item.strDate | faNum }} </td>

                            <td> {{ item.iCredit | number:'1.0-0' | faNum }} </td>

                            <td> {{ item.iDebit | number:'1.0-0' | faNum }} </td>

                            <td [innerHTML]="highlightText(item.strDetail,keyValue.value) | faNum"> </td>

                        </tr>

                    </tbody>

                </table>

            </div>

            <div class="row justify-content-center gx-0 gy-0 p-2" style="background-color: #6C757D;">

                <span class="col-md-auto col-12 text-white"> سرجمع بستانکاری : 
                    
                    <span class="text-primary fw-bold"> 
                        
                        {{ iCredit | number:'1.0-0' | faNum }} ریال 
                    
                    </span>

                </span>

                <span class="col-md-auto col-12 text-white mx-md-5 mx-3"> سرجمع بدهکاری : 
                    
                    <span class="text-primary fw-bold"> 
                        
                        {{ iDebit | number:'1.0-0' | faNum }} ریال 
                    
                    </span>

                </span>
    
            </div>

        </div>

    </div>

</section>